module.exports = {
	setValue(state, payload) {
		Vue.set(state, payload.key, payload.value);
	},

	updateAttributeFields(state, payload) {
		let attribute = _.find(state.attributes, item => {
			return item.id === +payload.data.id;
		});

		_.forEach(payload.data, (value, key) => {
			if (key !== "id") {
				Vue.set(attribute, key, value);
			}
		});
	},

	updateUserFields(state, payload) {
		let user = _.find(state.users, item => {
			return item.id === +payload.data.id;
		});

		if (user === undefined) {
			return;
		}

		_.forEach(payload.data, (value, key) => {
			if (key !== "id") {
				Vue.set(user, key, value);
			}
		});
	},

	updatePermissions(state, payload) {
		let index = _.findIndex(state.roles, { id: payload.id });

		Vue.set(state.roles[index], "permissions", payload.permissions);
	},

	deleteUser: (state, id) => {
		const index = _.findIndex(state.users, { id });

		state.users.splice(index, 1);
	},

	setPermissionGroups: (state, payload) => {
		Vue.set(state, "permissionGroups", payload);
	}
};
